import { Cirus } from "@/classes/Http";

export function checkReferralCode(code: string) {
    const query = `/user/check-referral/${code}`;
    return Cirus.get(query, {}, {}, true, process.env.VUE_APP_authURL, null, {404: 'کد معرف یافت نشد.',
    406: 'موجودی دعوت کد معرف به پایان رسیده است. کد معرف دیگری نیاز دارید.'});
}